// eslint-disable-next-line import/prefer-default-export
export const USER_TOKEN_KEY = 'auth_token';
export const USER_ID = 'userIdLearnSafe';
export const CURRENT_ORG = 'current_org';
